/**
 * 角色的中文名（顶栏、首页「当前角色」、账号管理里的角色标签共用）。
 *
 * 用 Record<AdminRole, string>：新增角色时 tsc 会在这里报缺项，不会再出现
 * 「新角色在页面上显示成裸英文 / undefined」。
 */
import type { AdminRole } from '../contracts/roles';

export const ROLE_LABELS: Record<AdminRole, string> = {
  super_admin: '超级管理员',
  operator: '运营',
  support: '客服',
  finance: '财务',
  observer: '只读观察员',
  sales: '销售',
  ops_lead: '运营主管',
};

/** role 来自会话 / 接口，类型上是 string：未知值原样返回，null 时给 fallback。 */
export function roleLabel(role: string | null | undefined, fallback = '未知'): string {
  if (!role) return fallback;
  return Object.prototype.hasOwnProperty.call(ROLE_LABELS, role) ? ROLE_LABELS[role as AdminRole] : role;
}
